import React from 'react';

import { cssMap } from '@compiled/react';

import Avatar from '@atlaskit/avatar';
import Heading from '@atlaskit/heading';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import type { PersonElement } from '../../dynamic-layout-parser/types/dynamic-layout-section';

const PersonCarouselCardStyles = cssMap({
	personCardWrapper: {
		borderRadius: token('radius.medium'),
		display: 'flex',
		flexDirection: 'column',
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
		boxSizing: 'border-box',
		width: '100%',
		maxWidth: '360px',
	},
	contactInfoSection: {
		marginLeft: token('space.100'),
		flex: 1,
		minWidth: '0px',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
});

interface PersonCarouselCardProps {
	component: PersonElement;
}

export const DynamicLayoutPersonCard = ({
	component,
}: PersonCarouselCardProps): React.JSX.Element => {
	const personAttributes = component.attributes;
	const { name, job_title, avatar_url } = personAttributes || {};

	return (
		<Box xcss={PersonCarouselCardStyles.personCardWrapper} testId="dynamic-layout-person-card">
			<Inline alignBlock="center">
				<Box>
					<Avatar appearance="circle" src={avatar_url || ''} size="large" />
				</Box>
				<Box xcss={PersonCarouselCardStyles.contactInfoSection}>
					<Stack space="space.050">
						<Heading size="xsmall">{name}</Heading>
						<Text size="small" maxLines={1}>
							{job_title}
						</Text>
					</Stack>
				</Box>
			</Inline>
		</Box>
	);
};
